import React, { useEffect, useState } from 'react';

import { VelocityComponent } from 'velocity-react';

const FIRE = '#D63D1F';
const FIRE_GLOW = '#FF6B3D';
const ACCENT_GREEN = '#2E8B57';
const SECONDARY_DARK = '#242F3F';

const BookingSuccess = ({ demoRequestID, onClose }) => {

    const [opacity, setOpacity] = useState(0);
    const [scale, setScale] = useState(0.95);

    const onDismiss = () => {
        setOpacity(0);
        setScale(0.95);
        setTimeout(onClose, 250);
    }

    const onBackdropClick = evt => {
        if(evt.target === evt.currentTarget) {
            onDismiss();
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setOpacity(1);
            setScale(1);
        }, 50);
    }, []);

    return (
        <div
        onClick={onBackdropClick}
        style={{
            alignItems: 'center',
            backgroundColor: 'rgba(15,20,28,0.65)',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            left: 0,
            padding: 24,
            position: 'fixed',
            top: 0,
            width: '100%',
            zIndex: 9950
        }}>
            <VelocityComponent
            animation={{ opacity: opacity, scale: scale }}
            duration={250}
            easing={[250, 20]}>
                <div style={{
                    backgroundColor: '#FFFFFF',
                    border: `2px solid ${FIRE}`,
                    borderRadius: 24,
                    boxShadow: `0 0 0 4px rgba(214,61,31,0.15)`,
                    maxWidth: 448,
                    overflow: 'hidden',
                    width: '100%'
                }}>
                    <div style={{
                        padding: '32px 24px',
                        textAlign: 'center'
                    }}>
                        <div style={{
                            alignItems: 'center',
                            backgroundColor: 'rgba(46,139,87,0.1)',
                            borderRadius: '50%',
                            display: 'flex',
                            height: 56,
                            justifyContent: 'center',
                            margin: '0 auto 16px auto',
                            width: 56
                        }}>
                            <i
                            className={'fas fa-check'}
                            style={{
                                color: ACCENT_GREEN,
                                fontSize: 28
                            }} />
                        </div>
                        <h4 style={{
                            color: SECONDARY_DARK,
                            fontFamily: '"Poppins", sans-serif',
                            fontSize: 24,
                            fontWeight: 700,
                            margin: '0 0 8px 0'
                        }}>{'Appointment Booked!'}</h4>
                        <p style={{
                            color: '#6F6F6F',
                            fontFamily: '"Lato", sans-serif',
                            fontSize: 14,
                            lineHeight: 1.6,
                            margin: '0 auto 24px auto',
                            maxWidth: 384
                        }}>{`Your home safety inspection has been successfully scheduled. We look forward to delivering your free Emergency Preparedness Kit and assisting with your home safety needs. Your confirmation id is DMR-${demoRequestID}`}</p>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <button
                            onClick={onDismiss}
                            style={{
                                background: `linear-gradient(90deg, ${FIRE}, ${FIRE_GLOW})`,
                                border: 'none',
                                borderRadius: 999,
                                color: '#FFFFFF',
                                cursor: 'pointer',
                                fontFamily: '"Poppins", sans-serif',
                                fontSize: 18,
                                fontWeight: 600,
                                padding: '12px 32px',
                                transition: 'transform 0.3s'
                            }}
                            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; }}
                            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}>{'Close'}</button>
                        </div>
                    </div>
                </div>
            </VelocityComponent>
        </div>
    )
}

export default BookingSuccess;
